import DocumentServices from '../services/DocumentServices'
import ConstancyService from '../services/ConstancyService'

export default {
  namespaced: true,
  state: () => ({
    documents: [],
    documentsTotal: 0,
    isDocumentsBusy: false,
    isDeletingDocument: false,
    documentSignLabels: {
      actionButtonText: 'Firmar',
      questionText: '¿Deseas firmar este documento?',
      descriptionText:
        'Al aceptar asumes que el documento se firmará a tu nombre. En algun punto aqui aparecerá la peticion de firmado con la FIEL.',
      positiveButtonText: 'Firmar',
      negativeButtonText: 'Cancelar'
    },
    documentDeleteLabels: {
      questionDeleteText: '¿Quieres eliminar este documento?',
      questionCancelText: '¿Quieres cancelar este documento?',
      descriptionDeleteText:
        'Al eliminar el documento aceptas que la información se perderá y no podrá recuperarse.',
      descriptionCancelText:
        'Al cancelar el documento la información no se perderá, sin embargo ya no se podrá continuar con la firma del mismo.',
      positiveButtonText: 'Aceptar',
      negativeButtonText: 'Cancelar'
    },
    documentGenerateConstancies: {
      questionConstancies: '¿Deseas generar la constancias?',
      descriptionConstanciesText:
        'Al dar clic en si su constancia se generara a partir del documento: "@" ',
      positiveButtonText: 'Si',
        negativeButtonText: 'No'
    },
    documentTableLabels: {
      loadingText: 'Buscando tus documentos...',
      noDataText: 'No hay documentos disponibles.'
    },
    documentsHeaders: [
      { text: 'Clave', value: 'clave', width: '110' },
      { text: 'Tipo Documento', value: 'idTipoDocumento', width: '170', order: 'tipoDocumento' },
      { text: 'Carpeta', value: 'idCarpeta', width: '160', order: 'carpeta' },
      { text: 'Nombre del documento', value: 'descripcion', width: '220', order: 'nombreDocumento' },
      { text: 'Estado', value: 'estatus', width: '90', order: 'estado' },
      { text: 'Firmantes', value: 'firmantes', sortable: false, width: '230' },
      { text: 'Creación', value: 'fechaSubidaS3', width: '120' },
      {
        text: 'Firmado',
        value: 'fechaConstancia',
        width: '90'
      },
      { text: 'Acciones', value: 'actions', sortable: false, width: '80' }
    ],
    msgDocumentServiceError:
      'No se pudo realizar la operación solicitada sobre el documento.',
    selectedFolder: ''
  }),
  mutations: {
    SET_DOCUMENTS(state, documents) {
      state.documents = documents
    },
    SET_DOCUMENTS_BUSY(state, isBusy) {
      state.isDocumentsBusy = isBusy
    },
    SET_DOCUMENTS_TOTAL(state, total) {
      if(Number.isInteger(total))
        state.documentsTotal = total
    },
    SET_SELECTED_FOLDER(state, selectedFolder) {
      state.selectedFolder = selectedFolder
    }
  },
  actions: {
    documentsBusy({ commit }) {
      commit('SET_DOCUMENTS_BUSY', true)
    },
    documentsUnnocupied({ commit }) {
      commit('SET_DOCUMENTS_BUSY', false)
    },
    getDocuments({ commit }, options) {
      const service = new DocumentServices()
      commit('SET_DOCUMENTS', [])
      commit('SET_DOCUMENTS_TOTAL', 0)
      commit('SET_DOCUMENTS_BUSY', true)
      commit('SET_SELECTED_FOLDER', '')
      return new Promise((resolve, reject) => {
        service.getDocuments(options)
        .then(result=>{
          if(result.data.successful.code == 'DOCUMENT-GET-200'){
            let docs = result.data.data.data.map(d => {
              return {
                ...d,
                firmantes: []
              }
            })
            commit('SET_DOCUMENTS', docs)
            commit('SET_DOCUMENTS_TOTAL', result.data.data.pagination.total)
            resolve(result.data.successful.code)
            resolve({code: result.data.successful.code, docs: docs, total:result.data.data.pagination.total})
          }else{
            reject(result)
          }
        })
        .catch(err=>{
          if(err.response.data.error.code == 'DOCUMENT-GET-411'){
            resolve(err.response.data.error.code)
          }
          reject(err)
        })
        .finally(()=>{
          commit('SET_DOCUMENTS_BUSY', false)
        })
      })
    },
    getDocumentsByFolder({ commit }, options) {
      const service = new DocumentServices()
      commit('SET_DOCUMENTS', [])
      commit('SET_DOCUMENTS_TOTAL', 0)
      commit('SET_DOCUMENTS_BUSY', true)
      commit('SET_SELECTED_FOLDER', options.idCarpeta)

      return new Promise((resolve, reject) => {
        service.getDocumentsByFolder(options)
        .then(result=>{
          if(result.data.successful.code == 'DOCUMENT-GET-200'){
            let docs = result.data.data.data.map(d => {
              return {
                ...d,
                firmantes: []
              }
            })
            commit('SET_DOCUMENTS', docs)
            commit('SET_DOCUMENTS_TOTAL', result.data.data.pagination.total)
            resolve({code: result.data.successful.code, docs: docs, total:result.data.data.pagination.total})
          }else{
            reject(result)
          }
        })
        .catch(err=>{
          if(err.response.data.successful.code == 'DOCUMENT-GET-411'){
            resolve(err.response.data.successful.code)
          }
          reject(err)
        })
        .finally(()=>{
          commit('SET_DOCUMENTS_BUSY', false)
        })
      })
    },
    deleteDocument({ commit, state }, id) {
      const service = new DocumentServices()

      return new Promise((resolve, reject) => {
        service
          .deleteDocument(id)
          .then(result => {
            if (result.data.successful.code == 'DOCUMENT-DELETE-200') {
              let newList = state.documents.filter(d => {
                return d.idDocumento != id
              })
              state.documentsTotal = state.documentsTotal - 1 
              commit('SET_DOCUMENTS', newList)
              commit('SET_DOCUMENTS_TOTAL', state.documentsTotal)
              resolve(result)
            } else if (result.data.successful.code == 'DOCUMENT-DELETE-201') {
              let updDoc = result.data.data
              let newList = state.documents.map(d => {
                return d.idDocumento == id ? Object.assign(d, updDoc) : d
              })
              commit('SET_DOCUMENTS', newList)
              resolve(result)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    updateDocument({ commit, state }, data) {
      const service = new DocumentServices()
      data = Object.assign({}, data)
      const id = data.idDocumento
      delete data['idDocumento']
      
      return new Promise((resolve, reject) => {
        service
          .updateDocument(id, data)
          .then(result => {
            if (result.data.successful.code == 'DOCUMENT-PUT-200') {
              let updDoc = result.data.data
              let newList = state.documents.map(d => {
                  return d.idDocumento == id ? Object.assign(d, updDoc) : d
                })
              if(state.selectedFolder !== '' && updDoc.idCarpeta !== state.selectedFolder) {
                newList = state.documents.filter(d => d.idDocumento !== updDoc.idDocumento);     
              }
              commit('SET_DOCUMENTS', newList);
              commit('SET_DOCUMENTS_TOTAL', newList.length)
              resolve(result)
            } else {
              reject(result)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    createDocumentConstancy({ commit, state }, documentId) {
      const service = new ConstancyService()
      let data = {'idDocumento': documentId}

      return new Promise(resolve => {
        service
        .crearConstancia(data)
        .then(res => {
          let updDoc = res.data.data
          updDoc.estatus = updDoc.status
          let newList = state.documents.map(d => {
            return d.idDocumento == documentId ? Object.assign(d, updDoc) : d
          })
          commit('SET_DOCUMENTS', newList)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    updateDocumentInStorage({ commit, state }, updDoc) {
      let newList = state.documents.map(d => {
        return d.idDocumento == updDoc.idDocumento ? Object.assign(d, updDoc) : d
      })
      commit('SET_DOCUMENTS', newList)
    },
    signDocumentInStorage({ commit, state }, {documentId, status, signerId}) {
      let newList = state.documents.map(d => {
        if(d.idDocumento == documentId){
          
          let signers = d.firmantes.map(s => {
            if(s.idFirmante == signerId){
              s.firmado = true
            }
            return s
          })

          let doc = Object.assign({}, d)
          doc.estatus = status
          doc.firmantes = signers
          return doc
        }
        return d
      })
      commit('SET_DOCUMENTS', newList)
    },
    addDocumentInStorage({ commit, state }, doc) {
      let newList = [doc]
      newList = newList.concat(state.documents)
      state.documentsTotal = state.documentsTotal + 1 
      commit('SET_DOCUMENTS', newList)
      commit('SET_DOCUMENTS_TOTAL', state.documentsTotal)
    },
    clearDocumentInStorage({ commit, state }) {
      commit('SET_DOCUMENTS', [])
      commit('SET_DOCUMENTS_TOTAL', 0)
      commit('SET_SELECTED_FOLDER', '')
    }
  },
  getters: {
    documents(state) {
      return state.documents
    },
    documentsTotal(state) {
      return state.documentsTotal
    },
    documentsHeaders(state) {
      return state.documentsHeaders
    },
    isDocumentsBusy(state) {
      return state.isDocumentsBusy
    },
    loadingText(state) {
      return state.documentTableLabels.loadingText
    },
    noDataText(state) {
      return state.documentTableLabels.noDataText
    },
    documentSignLabels(state) {
      return state.documentSignLabels
    },
    documentDeleteLabels(state) {
      return state.documentDeleteLabels
    },
    documentGenerateConstancies(state) {
      return state.documentGenerateConstancies
    },
    isDeleting(state) {
      return state.isDeletingDocument
    },
    msgDocumentServiceError(state) {
      return state.msgDocumentServiceError
    }
  }
}
